import { CHECKOUT_PAYMENT_REQUEST, CHECKOUT_PAYMENT_RESET, CHECKOUT_PAYMENT_REDIRECTED, CHECKOUT_PAYMENT_FREE, CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS, CHECKOUT_PAYMENT_USE_CREDITS, CHECKOUT_PAYMENT_NOT_USE_CREDITS } from "../types";

export const proceedWithCheckout = (stripeInstance, formData, card, type) => ({ type: CHECKOUT_PAYMENT_REQUEST, payload: { stripeInstance, formData, card, type }});

export const resetCheckout = () => ({ type: CHECKOUT_PAYMENT_RESET });

export const onSuccessRedirect = () => ({ type: CHECKOUT_PAYMENT_REDIRECTED });

export const onFreePassClick = () => ({ type: CHECKOUT_PAYMENT_FREE });

export const toggleCreditsPayment = () => ({ type: CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS });

export const setOnCreditsPayment = () => ({ type: CHECKOUT_PAYMENT_USE_CREDITS });

export const setOffCreditsPayment = () => ({ type: CHECKOUT_PAYMENT_NOT_USE_CREDITS });

